import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { formatErr } from "../lib/api";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back");
            nav("/feed");
        } catch (err) {
            toast.error(formatErr(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-wta-bg text-white grid md:grid-cols-2">
            <div className="hidden md:block relative overflow-hidden">
                <img src="https://images.unsplash.com/photo-1774988353278-b01caf489c4e" alt="" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-r from-wta-bg via-wta-bg/40 to-transparent" />
                <div className="relative p-12 h-full flex flex-col justify-end">
                    <div className="font-heading text-xs tracking-[0.4em] text-wta-accent">WELCOME BACK</div>
                    <h1 className="font-heading text-6xl tracking-tight uppercase mt-4">The Arena<br />Missed You.</h1>
                </div>
            </div>
            <div className="flex items-center justify-center p-6 md:p-12">
                <form onSubmit={onSubmit} className="w-full max-w-sm">
                    <Link to="/" data-testid="back-home" className="inline-block">
                        <img src="/wta-logo.png" alt="World Talent Arena" className="h-14 w-auto" />
                    </Link>
                    <h2 className="font-heading text-4xl tracking-tight uppercase mt-10">Log in</h2>
                    <p className="text-wta-muted text-sm mt-1">Enter your credentials to compete.</p>

                    <div className="mt-8 space-y-4">
                        <div>
                            <label className="text-xs tracking-widest text-wta-muted uppercase">Email</label>
                            <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full bg-wta-surface border border-wta-border rounded-sm px-4 py-3 text-sm" />
                        </div>
                        <div>
                            <label className="text-xs tracking-widest text-wta-muted uppercase">Password</label>
                            <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full bg-wta-surface border border-wta-border rounded-sm px-4 py-3 text-sm" />
                        </div>
                    </div>

                    <button data-testid="login-submit" type="submit" disabled={loading} className="mt-6 w-full btn-primary py-3 rounded-sm text-base disabled:opacity-50">
                        {loading ? "..." : "Log in"}
                    </button>
                    <div className="text-sm text-wta-muted mt-6 text-center">
                        New to WTA?{" "}
                        <Link to="/register" data-testid="goto-register" className="text-wta-primary hover:underline">Create account</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
